// app/materia/materie.js

(function () {
    'use strict';
    var controllerId = 'schedaCompetenze';
    angular.module('app').controller(controllerId, ['$rootScope', 'common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', '_', '$filter', '$translate', schedaCompetenze]);

    function schedaCompetenze($rootScope, common, bDialog, $routeParams, $uibModal, datacontext, sectionMenu, _, $filter, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Didattica per Competenze';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        //Gestione sola lettura        
        vm.super = $rootScope.isAuthorized('SUPER');
        vm.list = {};
        vm.list.ordine = ['anno', 'titolo', 'anno scolastico'];
        if (!vm.super)
            vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        vm.objName = "schedaCompetenze"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.page = 1;
        vm.loading = false;
      //  vm.addDisabled = !$rootScope.licenzaValida;
        vm.exportDisabled = false;
        vm.addTitle = 'Nuova Didattica per Competenze';
        vm.flag_modifica = 0;
        vm.cella_modificata = cella_modificata;

        //Filtro
        vm.filter = {};        
        vm.filter.titolo = ' ';
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
                
        vm.add = addModal;
        vm.update = updateItem;
        vm.delete = deleteItem;
        vm.close = close;

        //modali edit in html
        vm.editModalAbilita = editModalAbilita;
        vm.editModalConoscenze = editModalConoscenze;

        vm.get = getRecord;
        vm.addRigaAsse = addRigaAsse;
        vm.delRigaAsse = delRigaAsse;
        vm.addRigaCompChiave = addRigaCompChiave;
        vm.delRigaCompChiave = delRigaCompChiave;
        vm.addRigaCompBase = addRigaCompBase;
        vm.delRigaCompBase = delRigaCompBase;

        vm.attivo = attivo;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId).then(function () { });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;            
            vm.filter.titolo = vm.fTitolo == null ? '' : vm.fTitolo;            
            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.schedaCompetenze_countAll(vm.filter.titolo).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
           
            return datacontext.schedaCompetenze_getAll(vm.pageSize, vm.page, vm.filter.titolo, vm.ordine).then(function (data) {                   
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                }
                    //vm.records.forEach(function (item, index) {
                    //    //console.info('[' + index + '] ' + item);
                    //console.info("assi", vm.records[index].AssiCulturali);


                    //    vm.records[index].AssiCulturali.forEach(function (item, index2) {
                    //        //console.info('[' + index + '] ' + item);
                    //        console.info("competenzechiave", vm.records[index].AssiCulturali[index2].CompetenzeChiave);

                        
                    //            vm.records[index].AssiCulturali[index2].CompetenzeChiave.forEach(function (item, index3) {
                    //            //console.info('[' + index + '] ' + item);
                    //            console.info("competenzebase", vm.records[index].AssiCulturali[index2].CompetenzeChiave[index3].CompetenzeBase);
                    //            });
                    //        });
                    //});
                    vm.loading = false;
                });            
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.schedaCompetenze_get(id).then(function (data) {
                //console.info("data",data);
                vm.index = index;
                vm.record = data;

                if (!vm.record.AssiCulturali || vm.record.AssiCulturali.length == 0)
                    vm.record.AssiCulturali = [
                        {
                            Id: 0,
                            SchedaId: vm.record.Id,
                            Asse:''
                        }
                    ];
                
                setView('detail');
                return vm.record;
            });
        }
                
        function updateItem() {
            return datacontext.schedaCompetenze_update(vm.record).then(function (data) {
                if (data){
                    logSuccess($translate.instant('DatoSalvato'));
                   
                    //getRecord aggiorna la schermata direttamente e ricarica da db
                    getRecord(data.Id, 0); //in questo caso non abbiamo bisogno dell'index perchè la lista della schedaCompetenze.html non deve esseer poi aggiornata quindi non ci interessa tenere traccia dell'index
                    vm.flag_modifica = 0;
                    //console.info("vm.flag_modifica", vm.flag_modifica);
                }
                else
                     logError($translate.instant('ImpossibileSalvareDati'));
                });
            
            }
        

        function deleteItem(item) {
               var msg = ' ' + $translate.instant('schedaCompetenze') + ' ' + item.Titolo;
                bDialog.deleteDialog(msg).then(function () {
                    return datacontext.schedaCompetenze_delete(item.Id).then(function (data) {
                        if (data != "204") return logError($translate.instant('ErroreRimozione'));

                        var index = vm.records.indexOf(item);
                        vm.records.splice(index, 1);
                        vm.countRecords--;
                    });
                });
            }            
        

        function addRigaAsse() {
            var riga = {
                'Id': 0,
                'SchedaId': vm.record.Id,
                'Asse': '',
                'CompetenzeChiave': []
            };
           
            vm.record.AssiCulturali.push(riga);
        }

        function delRigaAsse(index, recordForm) {
            var msg = ' l\'asse culturale ' + vm.record.AssiCulturali[index].Asse;
            bDialog.deleteDialog(msg).then(function () {
                vm.record.AssiCulturali.splice(index, 1);
                vm.flag_modifica = 1;
                recordForm.$setDirty();
            });
        }

        
        function addRigaCompChiave(item) {

            var riga = {
                'Id': 0,
                'AsseId': item.Id,
                'CompChiave': '',
                'CompetenzeBase': []
            };

            item.CompetenzeChiave.push(riga);
        }

       
        function delRigaCompChiave(item, index, recordForm) {
            var msg = ' la competenza chiave ' + item.CompetenzeChiave[index].CompetenzaChiave;
            bDialog.deleteDialog(msg).then(function () {
                item.CompetenzeChiave.splice(index, 1);
                vm.flag_modifica = 1;
                recordForm.$setDirty();
            });
        }
        
        function addRigaCompBase(item) {

            var riga = {
                'Id': 0,
                'CompChiaveId':item.Id,
                'CompBase': '',
                'Abilita': '',
                'Conoscenza':''
            };
            item.CompetenzeBase.push(riga);
        }

        
        function delRigaCompBase(item, index, recordForm) {
            var msg = ' la competenza base ' + item.CompetenzeBase[index].CompetenzaBase;
            bDialog.deleteDialog(msg).then(function () {
                item.CompetenzeBase.splice(index, 1);
                vm.flag_modifica = 1;
                recordForm.$setDirty();
            });
        }

        function attivo(index, value) {
            vm.records[index].Attivo = value;
            updateAttivo(index);
        }

        function updateAttivo(index) {
            return datacontext.schedaCompetenze_update(vm.records[index]).then(function (data) {
                if (data) {
                    logSuccess($translate.instant('DatoSalvato'));
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function cella_modificata() {
            return vm.flag_modifica = 1;
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            var modalSchedaCompetenze = {};
            modalSchedaCompetenze.Id = 0;   // devo aggiungere un nuovo record e sappiamo che ogni nuovo record è identificato da un Id pari a 0

            var modalInstance = $uibModal.open({
                templateUrl: '/app/schedaCompetenze/modal/schedaCompetenzeAdd.html',
                controller: 'schedaCompetenzeAdd',
                resolve: {                      // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                    schedaCompetenze: function () {
                        return modalSchedaCompetenze;
                    }
                   
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato ');

                logSuccess('Record creato con successo ');
               // addRecord(returnItem.Id);
                cerca();

            });
        }

        //modale per formattare in html il campo abilità
        function editModalAbilita(item, recordForm) {
            var modalAbilita = {};
            angular.copy(item, modalAbilita);
         
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/schedaCompetenze/modal/schedaCompetenzeAbilitaEdit.html',
                controller: 'schedaCompetenzeAbilitaEdit',
                resolve: {                      // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                    schedaCompetenzeAbilita: function () {
                        return modalAbilita;
                    }

                }
            });

            modalInstance.result.then(function (returnItem) {
                item.Abilita = returnItem.Abilita; //item.Abilita è l'oggetto originale a cui assegno l'oggetto modificato nella modale
                vm.flag_modifica = 1;
                recordForm.$setDirty();
                if (!returnItem) return logError('Errore durante la modifica del dato ');

                //logSuccess('Record modificato con successo ');
                //vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione  
                // addRecord(returnItem.Id);
                //cerca();

            });
        }

        
        //modale per formattare in html il campo Conoscenze
        function editModalConoscenze(item, recordForm) {
            var modalConoscenze = {};
            angular.copy(item, modalConoscenze);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/schedaCompetenze/modal/schedaCompetenzeConoscenzeEdit.html',
                controller: 'schedaCompetenzeConoscenzeEdit',
                resolve: {                      // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                    schedaCompetenzeConoscenze: function () {
                        return modalConoscenze;
                    }

                }
            });

            modalInstance.result.then(function (returnItem) {
                item.Conoscenze = returnItem.Conoscenze; //item.Conoscenza è l'oggetto originale che ho quando mi si apre la modale(quel dettaglio in particolare) a cui assegno l'oggetto modificato in html nella modale
                vm.flag_modifica = 1;
                recordForm.$setDirty();
                if (!returnItem) return logError('Errore durante la modifica del dato ');

                //logSuccess('Record modificato con successo ');
                //vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione  
                // addRecord(returnItem.Id);
                //cerca();

            });
        }

       
    }
})();